import styled, { css } from "styled-components";
import { ReactComponent as ArrowPrev } from "assets/images/arrow-prev.svg";
import { ReactComponent as ArrowNext } from "assets/images/arrow-next.svg";
import { fonts } from "styles";

export const ItemsWrapper = styled.section`
  width: 100%;
  max-width: 474px;
  display: flex;
  overflow-x: hidden;
  margin-bottom: 40px;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  --webkit-overflow-scrolling: touch;

  &.unsetScrollBehavior {
    scroll-behavior: unset;
  }

  @media screen and (max-width: 414px) {
    margin-bottom: 24px;
  }
`;

export const Item = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  column-gap: 24px;
  flex-shrink: 0;
  flex-grow: 0;

  span {
    display: block;
  }
`;

export const QuestionNumber = styled.div`
  font-family: ${fonts.BentonSansRegular};
  font-size: 24px;
  line-height: 43px;
  color: white;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: max-content;

  @media screen and (max-width: 414px) {
    font-size: 20px;
    line-height: 24px;
    display: none;
  }
`;

export const IconArrowForward = styled(ArrowNext)`
  margin-left: 8px;
  transition: 300ms ease;
  width: 12px;
  fill: white;
`;

export const QuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Question = styled.h3`
  font-family: ${fonts.BentonSansRegular};
  font-size: 20px;
  line-height: 26px;
  color: white;
  margin-bottom: 32px;

  @media screen and (max-width: 414px) {
    font-size: 15px;
    line-height: 20px;
    font-family: ${fonts.BentonSansBold};
    margin-bottom: 24px;
  }
`;

export const Answer = styled.article`
  font-family: ${fonts.BentonSansRegular};
  font-size: 15px;
  line-height: 22px;
  color: white;

  @media screen and (max-width: 414px) {
    font-size: 15px;
    line-height: 20px;

    max-height: 200px;
    overflow-y: scroll;
  }
`;

export const IconArrowPrev = styled(ArrowPrev)`
  transition: 300ms ease;
`;

export const IconArrowNext = styled(ArrowNext)`
  transition: 300ms ease;
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: max-content;
  margin-left: 54px;

  @media screen and (max-width: 414px) {
    margin-left: 0;
  }
`;

export const Button = styled.button.attrs({ type: "button" })`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  padding: 13px 16px;
  transition: 300ms ease;

  &:hover {
    background-color: black;
    svg {
      fill: white;
    }
  }
`;

export const ButtonPrev = styled(Button)`
  border-radius: 5px 0 0 5px;
  border-right: 1px solid #707070;
`;

export const ButtonNext = styled(Button)`
  border-radius: 0 5px 5px 0;
`;

interface ContainerProps {
  lightMode?: boolean;
}
export const Container = styled.section<ContainerProps>`
  width: 100%;
  max-width: 474px;

  ${({ lightMode }) =>
    lightMode &&
    css`
      ${QuestionNumber} {
        color: black;
        svg {
          fill: #000;
        }
      }

      ${Question} {
        color: black;
      }
      ${Answer} {
        color: black;
      }

      ${Button} {
        background-color: black;
        svg {
          fill: white;
        }
        &:hover {
          background-color: white;
          svg {
            fill: #000;
          }
        }
      }
    `}
`;
